<div [formGroup]="billingInfoForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.billingAndPaymentInfo">請求・支払い情報</span>
  </div>

  <div class="role-checkboxes">
    <label class="role-checkbox">
      <mat-checkbox formControlName="hasCustomBillingRule" (change)="onHasCustomBillingRuleChange($event.checked)"></mat-checkbox>
      <span class="role-checkbox__label" i18n="@@adminSystem.distributorDetails.label.hasCustomBillingRule">詳細はシステム外で定める</span>
    </label>
  </div>

  <!-- この div は [hidden] を使うと「詳細はシステム外で定める」のチェック後に描画リフレッシュのタイミングが間に合わないっぽいので @if を使う -->
  @if(billingInfoForm.get('hasCustomBillingRule')?.value === true){
    <div class="admin-dialog__field-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label i18n="@@adminSystem.distributorDetails.label.customBillingRuleNotes">請求関連情報に関するメモ</mat-label>
        <input matInput formControlName="customBillingRuleNotes" />
      </mat-form-field>
    </div>
  }

  <!-- この div は @if を使うと 非表示時に #billingSourceFormComp に対する ViewChild が失敗するので [hidden] を使う -->
  <div [hidden]="billingInfoForm.get('hasCustomBillingRule')?.value === true">
    <div class="nested-address-box">
      <app-billing-source-form #billingSourceFormComp [billingSourceForm]="getBillingSourceGroup()"></app-billing-source-form>
    </div>
    <div class="nested-address-box">
      <app-billing-terms-form [billingTermsForm]="getBillingTermsGroup()"></app-billing-terms-form>
    </div>
  </div>
  
</div>